<template>
    <div class="page">
        <div class="page-content">
            <div id="mapContainer" style="width: 100%; height: 100%;"></div>
        </div>
    </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { get } from '@/utils/request.js';

export default {
    data() {
        return {
            map: null,//地图对象
            marker: null,//标记对象
            loaded: false,
            infoWindow: null,//弹窗对象
            storeList: [],
        }
    },
    mounted() {
        AMapLoader.reset();
        this.initMap();//加载地图
    },
    methods:{
        async initMap() {
            await AMapLoader.load({
                key: "0a340fa72e11df852e1769b6d0b7be88", // 申请好的Web端开发者Key，首次调用 load 时必填
                version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: ["AMap.Marker", "AMap.InfoWindow"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
                callback: "onAPILoaded",//回调函数
            });

            this.map = new window.AMap.Map("mapContainer", {//生成底图在mapContainer这个div里
                center: [117.227362, 31.820515], // 初始中心点坐标
                zoom: 14, // 初始缩放级别
            });

            this.getStoreLocation(31.820571, 117.227308);

            this.map.on("dragend", (res)=>{
                this.getStoreLocation(res.lnglat.lat, res.lnglat.lng);
            })
        },
        // 初始化完成地图
        onAPILoaded(res) {
            this.loaded = true;
        },
        // 移动了地图
        getStoreLocation(lat, lng){
            get("/shop/store/findListRange",{
                longitude: lng,
                latitude: lat,
                east: lng + 0.05,
                west: lng - 0.05,
                north: lat + 0.05,
                south: lat - 0.05,
            }).then((res)=>{
                if(res.success){
                    this.storeList = res.list;
                    this.addMarker();
                }
            })
        },

        // 添加点
        addMarker() {
            this.removeMarker();

            this.storeList.forEach(item => {
                //新增一个标记点
                let marker = new window.AMap.Marker({
                    map: this.map,
                    position: [item.longitude, item.latitude],
                });

                //顺便新增一个点击标记点出来的窗口
                let infoWindow = new window.AMap.InfoWindow({
                    content: `
                        <h3>${item.storeName}</h3>
                        <p>联系：${item.contactPerson}(${item.contactPhone})</p>
                        <p>地址：${item.storeAddress}</p>
                    `,
                    offset: new window.AMap.Pixel(0, -30),
                });

                // 点击标记点时显示信息窗体
                marker.on("click", () => {
                    infoWindow.open(this.map, marker.getPosition());
                });

                this.map.add(marker);
            })
        },

        // 清除点
        removeMarker() {
            this.map.clearMap();
        },
    }
}

</script>

<style lang="scss">

</style>